import React from 'react';
import { useSelector } from 'react-redux';
import SocialShareModalAICaptionsField from 'containers/SocialShareModal/SocialShareModalAICaptionsField';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';
import { useSocialShareModal } from 'containers/SocialShareModal/SocialShareModalContext';
import { twitterIsPostingSelector } from 'redux/modules/social';
import {
  TWITTER_DESCRIPTION_LENGTH_COUNTER,
  TWITTER_MAX_DESCRIPTION_CHARS,
} from './constants';

export type TwitterPostComposerStepProps = {};

const TwitterPostComposerStep: React.FC<TwitterPostComposerStepProps> = () => {
  const isPosting = useSelector(twitterIsPostingSelector);

  const { description, setDescription } = useSocialShareModal();

  return (
    <SocialShareModalBody loadingTitle="Tweeting Video" isLoading={isPosting}>
      <SocialShareModalAICaptionsField
        inputProps={{
          value: description,
          maxChars: TWITTER_MAX_DESCRIPTION_CHARS,
          countRemaining: TWITTER_DESCRIPTION_LENGTH_COUNTER,
          onChange: setDescription,
        }}
      />
    </SocialShareModalBody>
  );
};

export default TwitterPostComposerStep;
